import React, { useState } from "react";
import { Link } from "gatsby";
import styled, { createGlobalStyle, css } from "styled-components";
import { graphql } from "gatsby";

import Layout from "./main-layout"
import FullHeight from "../components/full-height-hero-section"
import LinkButton from "../components/link-button";
import ListWindow from "../components/list-window";
import CapresmaImage from "../components/capresma-hero";
import Card from "../components/card";
import PartaiLogo from "../components/partai-logo";
import GlitchyTitle from "../components/titles/glitchy";
import AppWindow from "../components/window-styled-container";
import Modal from "../components/modal";

import BackArrow from "../assets/svg/chevron-left.svg";

import mappingNamaPartai from "../mappings/nama-partai.json";

const GlobalStyle = createGlobalStyle`
    body {
        background-color: var(--kpum-cream);
    }
`;

const MainSection = styled(FullHeight)`
    & + section::before {
        content: "";

        display: block;
        width: 100%;
        height: 8rem;

        position: absolute;
        left: 0;
        bottom: 100%;
        z-index: -1;

        background-color: inherit;
        border-top-left-radius: 100% 5rem;
    }
`;

const Container = styled.div`
    width: auto;
    /* height: 100%; */
    box-sizing: border-box;

    display: flex;
    flex-grow: 1;
    align-items: flex-end;

    margin: 5rem;
    padding-top: 2rem;

    position: relative;

    @media only screen and (max-width: 768px) {
        flex-direction: column-reverse;
        align-items: center;
        margin: 2rem;
    }
`;

const GoBack = styled(Link)`
    position: absolute;
    top: 0;
    left: 0;

    display: flex;
    align-items: center;

    font-weight: 500;
    color: var(--kpum-black);
    transition: color 0.1s;

    &:hover {
        color: var(--kpum-orange);
    }

    svg {
        height: 1.5em;
        width: auto;
        fill: currentColor;

        margin-right: 0.5em;
    }

    svg, span {
        display: block;
    }
`;

const InfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    /* margin-left: 5em; */
    position: relative;
    flex-grow: 1; /* ? */

    @media only screen and (max-width: 768px) {
        text-align: center;
        margin-top: 2em;
    }
`;

const Nama = styled.h1`
    font-family: var(--qanelas-main);
    font-size: 4em;
    /* color: var(--kpum-orange); */
    margin: 0;

    /* @media only screen and (max-width: 768px) {
        text-align: center;
    } */
`;

const Fakultas = styled.p`
    font-family: var(--qanelas-main);
    font-size: 1.5em;
    font-weight: 700;
    text-transform: uppercase;

    display: block;
    padding: 0.3em 0.8em;
    background: linear-gradient(45deg, var(--kpum-orange) 0%, var(--kpum-lightorange) 150%);
    color: white;
    width: fit-content;
    border-radius: 999px;
    margin: 0.75rem 0 0 0;

    @media only screen and (max-width: 768px) {
        margin-left: auto;
        margin-right: auto;
    }
`;

const Partai = ({ pengusung }) => {
    const PartaiGroup = styled.div`
        /* h2 {
            font-weight: bold;
        } */
        margin: 2rem 0;
        /* width: fit-content;

        @media only screen and (max-width: 768px) {
            margin-left: auto;
            margin-right: auto;
        } */
    `;

    const PartaiHeading = styled.p`
        font-family: var(--qanelas-main);
        font-weight: ${props => props.as == "h2" ? "300" : "400"};
        font-size: 1.5em;
        margin: 0 0 1rem 0;
    `;

    const ItemContainer = styled.div`
        display: flex;
        align-items: center;
        font-size: 1.2em;
        width: fit-content;

        &:not(:last-child) {
            margin-bottom: 0.6em;
        }

        @media only screen and (max-width: 768px) {
            margin-left: auto;
            margin-right: auto;
        }
    `;

    const NamaPartai = styled.p`
        display: block;
        margin: 0;
        font-family: var(--qanelas-main);
        font-weight: normal;
        font-size: 1em;
        margin-left: 0.75em;
    `;

    return (
        <PartaiGroup>
            {pengusung=="Independen" ? (
                <PartaiHeading>Independen</PartaiHeading>
            ) : (
                <>
                    <PartaiHeading as="h2">Partai Pengusung:</PartaiHeading>
                    {pengusung.map(item => (
                    <ItemContainer>
                        <PartaiLogo nama={item} />
                        <NamaPartai>{mappingNamaPartai[item]}</NamaPartai>
                    </ItemContainer>
                    ))}
                </>
            )}
        </PartaiGroup>
    );
}

const ButtonGroup = styled.div`
    display: flex;
    width: fit-content;

    @media only screen and (max-width: 768px) {
        margin: 0 auto;
    }
`;

const HeroImage = styled(CapresmaImage)`
    @media only screen and (max-width: 768px) {
        width: auto;
        max-width: 350px;
        height: 200px;
        /* margin-left: auto;
        margin-right: auto; */
    }
`;

const dashedLineSectionDivider = color => css`
    &::before {
        content: "";
        display: block;
        width: 100%;
        height: 1px;
        background: repeating-linear-gradient(
            to right,
            ${color},
            ${color} 25px,
            transparent 25px,
            transparent 35px
        );
    }
`;

const VideografisSection = styled.section`
    padding: 5rem 2rem;
    background-color: var(--kpum-lightorange);
    position: relative;

    &::before {
        content: "";

        display: block;
        width: 100%;
        height: 8rem;

        position: absolute;
        left: 0;
        bottom: 100%;
        z-index: -1;

        background-color: inherit;
        border-top-left-radius: 100% 5rem;
    }

    & + section {
        ${dashedLineSectionDivider(`rgb(255 255 255 / 0.5)`)}
    }
`;

const VideografisWindow = styled(AppWindow)`
    width: fit-content;
    margin: 0 auto;
    overflow: hidden;

    iframe {
        display: block;
        width: 60rem;
        height: 40rem;

        @media only screen and (max-width: 640px) {
            height: 25rem;
        }

        @media only screen and (max-width: 480px) {
            height: 15rem;
        }

        max-width: 100%;

        /* Reset appearance */
        border: none;
        margin: 0;
        padding: 0;
    }
`;

const Visi = ({ children }) => {
    const VisiSection = styled.section`
        background-color: var(--kpum-lightorange);
        padding: 0 2rem;

        position: relative;

        &::after {
            content: "";
            display: block;
            position: absolute;
            width: 100%;
            background-color: inherit;
            left: 0;

            height: 12rem;
            top: 100%;
            z-index: -1;
            border-bottom-right-radius: 100% 5rem;
        }
    `;

    const VisiContainer = styled.div`
        max-width: 800px;
        width: fit-content;
        margin: 5rem auto;
        /* color: var(--kpum-black); */
    `;

    const Title = styled.h1`
        font-family: var(--qanelas-main);
        font-size: 1.5em;
        font-weight: normal;
    `;

    const Content = styled.p`
        display: block;
        font-family: var(--sekogure-main);
        font-size: 2em;
        /* font-weight: bold;
        font-style: italic; */
        text-decoration: underline;
        margin: 0;
        text-shadow: 0.05em 0.05em 0 var(--kpum-cream); /* ? */
    `;

    return (
        <VisiSection>
            <VisiContainer>
                <Title>Visi:</Title>
                <Content>{children}</Content>
            </VisiContainer>
        </VisiSection>
    )
};

const Proker = ({ contents }) => {
    const ProkerSection = styled.section`
        padding: 0 1rem;
        ${dashedLineSectionDivider(`rgb(0 0 0 / 0.2)`)}
    `;

    const Group = styled.ul`
        margin: 0;
        padding: 0;
        
        counter-reset: proker-count;
    `;

    const CustomCard = styled(Card).attrs({ as: "li" })`
        display: flex;
        list-style: none;

        background-color: rgb(255 255 255 / 0.6);
        box-shadow: 0 2px 5px rgb(0 0 0 / 0.25);
        max-width: 500px;
        margin: 0 auto;

        padding: 1.5em;

        counter-increment: proker-count;

        &:not(:last-child) {
            margin-bottom: 1em;
        }
    `;

    const Number = styled.div`
        display: block;
        /* width: 100px;
        height: 100px; */
        min-width: 1.5ch;
        text-align: right;
        margin-right: 0.6em;
        
        /* background-color: greenyellow; */
        font-size: 2.5em;
        font-style: italic;
        font-weight: 300;
        line-height: 1;

        &::after {
            content: counter(proker-count);
        }

        flex-shrink: 0; /* FIXME */
    `;

    const Name = styled.h2`
        margin: 0;
        padding: 0;
        font-size: 1em;
        font-weight: bold;
    `;

    const Description = styled.p`
        margin: 0.25em 0 0 0;
    `;

    const Item = ({ title, description }) => (
        <CustomCard>
            <Number />
            <div>
                <Name>{title}</Name>
                <Description>{description}</Description>
            </div>
        </CustomCard>
    );

    return (
        <ProkerSection>
            <GlitchyTitle>Program Unggulan</GlitchyTitle>
            <Group>
                {contents.map((item) => (<Item title={item.nama} description={item.deskripsi} />))}
            </Group>
        </ProkerSection>
    );
};

const SeeMore = styled.section`
    text-align: center;
    padding: 5rem 0 8rem 0;
`;

const ModalContent = styled.div`
    iframe {
        display: block;
        margin: 0 auto;

        height: 60vh;
        width: 60vw;

        @media only screen and (max-width: 768px) {
            width: 100%;
        }
    }
`;

const ModalDownloadButton = styled(LinkButton)`
    display: block;
    width: fit-content;
    margin: 1rem auto;
`;

const CapresmaPage = ({ data }) => {
    const [isModalOpen, setModalOpen] = useState(false);

    const [modalData, setModalData] = useState({
        iframeSrcUrl: null,
        downloadUrl: null
    });

    const createDriveDownloadUrl = id => `https://drive.google.com/u/1/uc?id=${id}&export=download`

    function showModal(e, driveFileId) {
        e.preventDefault();

        setModalData({
            iframeSrcUrl: `https://drive.google.com/file/d/${driveFileId}/preview`,
            downloadUrl: createDriveDownloadUrl(driveFileId)
        });

        setModalOpen(true);
    }

    const ButtonContainer = styled.a`
        margin-right: 1em;
        cursor: pointer;
    `;

    return (
        <Layout title={data.capresmaJson.nama}>
            <GlobalStyle />
            <MainSection>
                <Container>
                    <GoBack to="..">
                        <BackArrow />
                        <span>Kembali ke daftar capresma</span>
                    </GoBack>
                    <InfoContainer>
                        <Nama>{data.capresmaJson.nama}</Nama>
                        <Fakultas>{data.capresmaJson.fakultas}</Fakultas>
                        <Partai pengusung={data.capresmaJson.partai} />
                        <ButtonGroup>
                            <ButtonContainer onClick={e => showModal(e, data.capresmaJson.cvDriveFileId)}>
                                <LinkButton>
                                    CV
                                </LinkButton>
                            </ButtonContainer>
                            <ButtonContainer onClick={e => showModal(e, data.capresmaJson.grandDesignDriveFileId)}>
                                <LinkButton>
                                    <i>Grand Design</i>
                                </LinkButton>
                            </ButtonContainer>
                            <ButtonContainer onClick={e => showModal(e, data.capresmaJson.infografisDriveFileId)}>
                                <LinkButton>
                                    Infografis
                                </LinkButton>
                            </ButtonContainer>
                            <ButtonContainer onClick={e => showModal(e, data.capresmaJson.laporanKampanyeDriveFileId)}>
                                <LinkButton>
                                    Laporan Dana Kampanye
                                </LinkButton>
                            </ButtonContainer>
                        </ButtonGroup>
                    </InfoContainer>
                    <HeroImage noUrut={data.capresmaJson.fields.noUrut} animateOnEntrance />
                </Container>
            </MainSection>
            {data.capresmaJson.videografisUrl ? (
                <VideografisSection>
                    <VideografisWindow>
                        <iframe src={data.capresmaJson.videografisUrl} frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen"/>
                    </VideografisWindow>
                </VideografisSection>
            ) : null}
            <Visi>{data.capresmaJson.visi}</Visi>
            <section style={{ padding: `1rem` }}>
                <ListWindow title="Misi" contents={data.capresmaJson.misi} />
            </section>
            <Proker contents={data.capresmaJson.proker} />
            <SeeMore>
                <ButtonContainer onClick={e => showModal(e, data.capresmaJson.grandDesignDriveFileId)}>
                    <LinkButton
                        style={{ margin: `0 auto `}}
                        external
                    >Lihat selengkapnya di <i>Grand Design</i></LinkButton>
                </ButtonContainer>
            </SeeMore>

            {/* Modal dialog for displaying PDFs */}
            <Modal show={isModalOpen} handleClose={() => setModalOpen(false)}>
                <ModalContent>
                    <iframe src={modalData.iframeSrcUrl} />
                    <ModalDownloadButton external to={modalData.downloadUrl}>Unduh</ModalDownloadButton>
                </ModalContent>
            </Modal>
        </Layout>
    )
};

export default CapresmaPage;

export const query = graphql`
    query($slug: String!) {
        capresmaJson(fields: { slug: { eq: $slug } }) {
            fields {
                noUrut
            }
            nama
            fakultas
            partai
            visi
            misi
            proker {
                nama
                deskripsi
            }
            videografisUrl
            infografisDriveFileId
            cvDriveFileId
            grandDesignDriveFileId
            laporanKampanyeDriveFileId
        }
    }
`;